import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import FloatingCTA from "@/components/layout/FloatingCTA";
import ScrollToTop from "@/components/layout/ScrollToTop";

import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesIndexPage from "@/pages/ServicesIndexPage";
import ADUPage from "@/pages/ADUPage";
import PlumbingPage from "@/pages/PlumbingPage";
import HVACPage from "@/pages/HVACPage";
import DrywallPage from "@/pages/DrywallPage";
import RemodelingPage from "@/pages/RemodelingPage";
import ConstructionPage from "@/pages/ConstructionPage";
import RoofingPage from "@/pages/RoofingPage";
import ElectricalPage from "@/pages/ElectricalPage";
import ADUCalculatorPage from "@/pages/ADUCalculatorPage";
import AdminLeadsPage from "@/pages/AdminLeadsPage";
import GalleryPage from "@/pages/GalleryPage";
import ReviewsPage from "@/pages/ReviewsPage";
import FinancingPage from "@/pages/FinancingPage";
import ContactPage from "@/pages/ContactPage";
import ServiceAreaPage from "@/pages/ServiceAreaPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesIndexPage />} />
            <Route path="/services/adu" element={<ADUPage />} />
            <Route path="/services/plumbing" element={<PlumbingPage />} />
            <Route path="/services/hvac" element={<HVACPage />} />
            <Route path="/services/drywall" element={<DrywallPage />} />
            <Route path="/services/remodeling" element={<RemodelingPage />} />
            <Route path="/services/construction" element={<ConstructionPage />} />
            <Route path="/services/roofing" element={<RoofingPage />} />
            <Route path="/services/electrical" element={<ElectricalPage />} />
            <Route path="/adu-calculator" element={<ADUCalculatorPage />} />
            <Route path="/admin/leads" element={<AdminLeadsPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/reviews" element={<ReviewsPage />} />
            <Route path="/financing" element={<FinancingPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/areas/:slug" element={<ServiceAreaPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </main>
        <Footer />
        <FloatingCTA />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
